import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#19255B',
            light: '#D6E6FF',
            lighter: '#EFF5FF',
            background: '#F7FAFF',
        },
        secondary: { main: '#27536C', light: '#CCECF9' },
        gray: { main: '#CBCBCB', dark: '#797979', light: '#F0F0F0' },
        error: { main: '#FF7C8D' },
    },
    typography: {
        fontFamily: [
            'Noto Sans',
            '-apple-system',
            'BlinkMacSystemFont',
            'Segoe UI',
            'Roboto',
            'Helvetica Neue',
            'Arial',
            'sans-serif',
            'Apple Color Emoji',
            'Segoe UI Emoji',
            'Segoe UI Symbol',
        ].join(','),
    },
});

export default theme;
